/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorAnalyticsTable.vue?vue&type=template&id=2f5ea3de&scoped=true"
import script from "./DoctorAnalyticsTable.vue?vue&type=script&lang=js"
export * from "./DoctorAnalyticsTable.vue?vue&type=script&lang=js"
import style0 from "./DoctorAnalyticsTable.vue?vue&type=style&index=0&id=2f5ea3de&scoped=true&lang=css"
import style1 from "./DoctorAnalyticsTable.vue?vue&type=style&index=1&id=2f5ea3de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ea3de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5ea3de')) {
      api.createRecord('2f5ea3de', component.options)
    } else {
      api.reload('2f5ea3de', component.options)
    }
    module.hot.accept("./DoctorAnalyticsTable.vue?vue&type=template&id=2f5ea3de&scoped=true", function () {
      api.rerender('2f5ea3de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/DoctorAnalyticsTable.vue"
export default component.exports